import React from 'react';
import mixpanel from 'mixpanel-browser';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Button, TextField, InputLabel } from '@mui/material';

import { Loader } from '../../../components/Elements/Loader';

import {
  ConfirmVerificationInfoForm,
  locateFreeTrialReport,
} from '../../../constants/Pages/FreeTrialReport';

import './ConfirmFreeTrialModal.css';

export const ConfirmFreeTrialModal = () => {
  const navigate = useNavigate();
  const loading = false;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleConfirmFreeTrialForm = (val) => {
    mixpanel.track('Confirm_Free_Trial_Form', {
      financeLenderId: val['finance-lender'],
      freeTrialId: val['free-trial-report'],
    });
    navigate(`/partner/${val['finance-lender']}/free_trial/${val['free-trial-report']}`);
  };

  return (
    <div>
      <form className="confirm-free-trial-form">
        {ConfirmVerificationInfoForm.map(
          ({ name, placeholder, required, pattern, type, label }) => {
            return (
              <div key={name} className="free-trial-download-input-wrapper">
                <InputLabel
                  sx={{ color: 'gray', mb: 1, fontSize: '14px', fontFamily: 'sans-serif' }}
                >
                  {label}
                </InputLabel>
                <TextField
                  className={name}
                  name={name}
                  error={!!errors[name]}
                  helperText={errors[name]?.message}
                  placeholder={placeholder}
                  variant="outlined"
                  autoComplete="off"
                  type={type}
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '10px',
                    border: '1px solid gray',
                  }}
                  {...register(name, {
                    required,
                    pattern,
                  })}
                  disabled={loading}
                />{' '}
              </div>
            );
          },
        )}

        <div>
          <Button
            sx={{
              '&:disabled': { color: 'white', opacity: 0.4 },
              m: 0,
              color: 'white',
              backgroundColor: 'black',
              width: '100%',
              borderRadius: 2,
              height: '56px',
            }}
            disabled={loading}
            type="button"
            onClick={handleSubmit(handleConfirmFreeTrialForm)}
          >
            {loading ? <Loader /> : locateFreeTrialReport}
          </Button>
        </div>
      </form>
    </div>
  );
};
